import Raven from 'raven-js';
import { app } from '../../../bootstrap/core';
import ravenHttpInterceptor from './ravenHttpInterceptor';

// Configure and install raven to the angular application for sentry error tracking.
Raven.config('https://be8f320f92dd49eba514b65dee8d50bc@sentry.io/100799', {
  release: ENV_CONFIG.build,
  ignoreErrors: [/\$rootScope:inprog.*/],
})
  // .addPlugin(require('raven-js/plugins/angular'), angular)
  .install();

app.config(($ravenProvider, envServiceProvider) => {
  'ngInject';
  // There is a development flag to log errors rather than sending it to Sentry
  // when we are not in production environment.
  // $ravenProvider.development(!envServiceProvider.isProduction());
});

// Log HTTP response errors to Sentry
app.config(ravenHttpInterceptor);

app.run(($window) => {
  'ngInject';
  $window.Raven = Raven;
});

app.factory('errorTrackingService', ($raven) => {
  'ngInject';
  return {
    captureMessage: $raven.captureMessage,
    captureException: $raven.captureException,
    setUserContext: $raven.setUserContext,
  };
});
